/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MenuSection } from '../../models/menu-section';
import { UpdateMenuSectionRequest } from '../../models/update-menu-section-request';

export interface UpdateMenuSection$Params {

/**
 * ID sekcie
 */
  id: number;
      body: UpdateMenuSectionRequest
}

export function updateMenuSection(http: HttpClient, rootUrl: string, params: UpdateMenuSection$Params, context?: HttpContext): Observable<StrictHttpResponse<MenuSection>> {
  const rb = new RequestBuilder(rootUrl, updateMenuSection.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MenuSection>;
    })
  );
}

updateMenuSection.PATH = '/admin/menu/{id}';
